import * as React from 'react';
import { Container } from 'reactstrap';

import { Collection } from 'types/Collection';
import AdminSearch from '../../utils/AdminSearch';

import { Alerts, ErrorMessage, SuccessMessage } from 'components/utils/alerts';
import { RouteComponentProps, withRouter } from 'react-router';

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';

import 'styles/components/admin/tables/modal.scss';

interface State extends Alerts {
  collections: Collection[];
  editingCollectionIndex?: number;

  componentModalOpen: boolean;
  deleteModalOpen: boolean;

  tableIsLoading: boolean;
  page: number;
  sizePerPage: number;
  totalSize: number;

  deleteErrorMessage: string | JSX.Element | undefined;
  order?: string;
}

class Collections extends React.Component<RouteComponentProps, State> {
  _isMounted;
  tableColumns;

  constructor(props: RouteComponentProps) {
    super(props);
    this._isMounted = false;

    this.state = {
      componentModalOpen: false,
      deleteModalOpen: false,
      collections: [],

      tableIsLoading: true,
      page: 1,
      sizePerPage: 15,
      totalSize: 0,
      deleteErrorMessage: undefined
    };
  }

  async componentDidMount() {
    this._isMounted = true;
    // this.getCollections();
  }

  render() {
    const isAdmin = !!this.props.location.pathname.match(/admin/i)
    const isContributorPath = !!this.props.location.pathname.match(/contributor/i)

    return (
      <Container>
        <ErrorMessage message={this.state.errorMessage}/>
        <SuccessMessage message={this.state.successMessage}/>
        <AdminSearch
          limit={this.state.sizePerPage}
          path={'collections'}
        />
      </Container>
    );
  }
}

export default withRouter(Collections);